import { render, staticRenderFns } from "./edit-userCard.vue?vue&type=template&id=ff64c9b0"
import script from "./edit-userCard.vue?vue&type=script&lang=ts"
export * from "./edit-userCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports